var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkaaz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 40,
    viewBox: "0 0 157 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_470_3823)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.529 31.4502C122.897 29.3947 122.887 26.4841 124.426 24.3591L137.81 5.87443C138.242 5.27632 138.775 4.7814 139.366 4.38967C139.147 4.21698 138.924 4.04639 138.697 3.88212C129.306 -2.91617 116.08 -0.570047 109.638 9.22093C103.842 18.0305 105.794 29.978 114.092 36.4899C115.817 37.8441 117.685 38.874 119.629 39.5921C122.465 40.6409 125.656 39.6111 127.429 37.1617L128.775 35.3021C128.52 35.1378 128.27 34.9651 128.021 34.7861C126.68 33.8152 125.515 32.6906 124.531 31.4523L124.529 31.4502Z",
    fill: "url(#paint0_linear_470_3823)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.398 6.45673C147.898 5.28156 146.277 4.38649 144.588 3.761C142.814 3.10602 140.885 3.38823 139.369 4.3886C140.634 5.38475 141.753 6.50306 142.715 7.71824C144.594 10.0833 144.606 13.434 142.835 15.8813L128.775 35.2989C136.873 40.5577 147.839 38.3927 153.267 30.1455C158.302 22.4921 156.605 12.1114 149.398 6.45673V6.45673Z",
    fill: "url(#paint1_linear_470_3823)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.714 7.71893C141.749 6.50585 140.633 5.38754 139.367 4.38928C138.776 4.7789 138.243 5.27592 137.811 5.87404L124.427 24.3587C122.888 26.4837 122.898 29.3943 124.53 31.4498C125.512 32.686 126.679 33.8106 128.02 34.7836C128.269 34.9627 128.519 35.1353 128.774 35.2996L142.834 15.8819C144.605 13.4347 144.595 10.0861 142.714 7.71893V7.71893Z",
    fill: "url(#paint2_linear_470_3823)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M142.714 7.71893C141.749 6.50585 140.633 5.38754 139.367 4.38928C138.776 4.7789 138.243 5.27592 137.811 5.87404L124.427 24.3587C122.888 26.4837 122.898 29.3943 124.53 31.4498C125.512 32.686 126.679 33.8106 128.02 34.7836C128.269 34.9627 128.519 35.1353 128.774 35.2996L142.834 15.8819C144.605 13.4347 144.595 10.0861 142.714 7.71893V7.71893Z",
    fill: "url(#paint3_linear_470_3823)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.716 7.72015C141.751 6.50707 140.635 5.38877 139.369 4.3905C138.778 4.78012 138.245 5.27715 137.813 5.87526L124.429 24.36C122.89 26.485 122.9 29.3955 124.532 31.451C125.514 32.6872 126.681 33.8119 128.022 34.7849C128.271 34.9639 128.521 35.1366 128.776 35.3008L142.836 15.8832C144.607 13.4359 144.597 10.0873 142.716 7.72015V7.72015Z",
    fill: "white"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2842 15.8401C71.2842 12.8347 71.2821 9.82942 71.2884 6.82621C71.2884 6.26811 71.2736 5.70159 71.3642 5.15402C71.5916 3.77456 72.6931 2.81421 73.9483 2.83316C75.115 2.85001 76.0838 3.74718 76.246 5.15612C76.3723 6.26179 76.3218 7.38852 76.3281 8.50473C76.3408 10.6002 76.3239 12.6978 76.3513 14.7934C76.3513 14.7997 76.3513 14.8081 76.3513 14.8144C76.3744 15.383 77.0926 15.6926 77.5117 15.3051L77.518 15.2988C78.7395 14.1384 79.8852 12.8937 81.1425 11.7733C82.2292 10.8024 83.1685 10.6381 84.0804 11.1878C85.1377 11.8259 85.5357 13.1738 85.1187 14.3132C84.866 15.004 82.4377 17.4449 82.1829 17.725C81.8207 18.123 81.608 18.6221 81.6206 19.1655C81.629 19.5467 81.7491 19.9237 81.9618 20.2417C82.1934 20.5892 82.4188 20.9451 82.6526 21.2947C83.158 22.0487 83.6571 22.8068 84.1457 23.5713C84.4343 24.022 84.7123 24.479 84.9987 24.9318C85.7316 26.0859 85.6389 27.5707 84.3774 28.3668C83.2844 29.0555 81.6922 28.6995 80.9783 27.7076C80.039 26.4018 79.1839 25.0287 78.232 23.7293C78.2046 23.6914 78.1751 23.6577 78.1414 23.624C77.6633 23.1396 76.8357 23.3186 76.5219 23.923C76.4755 24.0136 76.4334 24.1063 76.4018 24.201C76.2734 24.5822 76.3471 25.0308 76.3281 25.4499C76.2291 27.6297 75.412 28.7985 73.963 28.8301C72.3035 28.8659 71.3157 27.5812 71.2926 25.273C71.2673 22.8279 71.2863 20.3807 71.2842 17.9356C71.2842 17.2364 71.2842 16.5372 71.2842 15.8401V15.8401Z",
    fill: "#25245F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4612 11.5061C61.6958 12.1443 61.6389 11.483 63.29 11.186C64.977 10.8849 66.9967 11.4788 68.4203 12.7845C69.4207 13.7006 69.3323 15.2528 68.6099 16.0868C67.837 16.9818 66.567 17.1566 65.6783 16.6996C65.4277 16.5712 65.1686 16.4553 64.9096 16.3437C62.5803 15.3391 61.0492 16.289 60.9755 18.8457C60.9186 20.8717 60.9692 22.8998 60.9523 24.9279C60.9481 25.5555 60.9586 26.1979 60.8217 26.8044C60.548 28.0112 59.8151 28.8557 58.4819 28.8073C57.231 28.7609 56.3717 28.0638 56.0537 26.8339C55.9505 26.4337 55.9231 26.0041 55.921 25.5871C55.9126 21.7415 55.8894 17.898 55.9273 14.0523C55.9442 12.2854 56.9235 10.7817 59.4549 11.504L59.4612 11.5061Z",
    fill: "#25245F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9236 13.8108C52.7804 11.6416 51.1082 10.338 49.3918 11.0983C48.084 11.6774 47.0078 11.4816 45.7463 11.132C39.8599 9.49557 34.6011 14.4806 34.4368 19.4592C34.2262 25.9206 40.4601 30.1116 45.7568 28.5721C46.6582 28.3088 47.7323 28.1656 48.6189 28.3888C51.3273 29.0754 52.8584 28.1087 52.9658 25.3393C53.0332 23.5955 53.0626 15.9 52.9236 13.8129V13.8108ZM43.615 23.9514C41.3236 23.9514 39.4661 22.0939 39.4661 19.8025C39.4661 17.5112 41.3236 15.6536 43.615 15.6536C45.9063 15.6536 47.7639 17.5112 47.7639 19.8025C47.7639 22.0939 45.9063 23.9514 43.615 23.9514Z",
    fill: "#25245F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.722 13.8108C104.579 11.6416 102.907 10.338 101.191 11.0983C99.8828 11.6774 98.8066 11.4816 97.5451 11.132C91.6587 9.49557 86.3999 14.4806 86.2357 19.4592C86.0251 25.9206 92.2589 30.1116 97.5556 28.5721C98.457 28.3088 99.5311 28.1656 100.418 28.3888C103.126 29.0754 104.657 28.1087 104.765 25.3393C104.832 23.5955 104.861 15.9 104.722 13.8129V13.8108ZM95.4138 23.9514C93.1224 23.9514 91.2649 22.0939 91.2649 19.8025C91.2649 17.5112 93.1224 15.6536 95.4138 15.6536C97.7052 15.6536 99.5627 17.5112 99.5627 19.8025C99.5627 22.0939 97.7052 23.9514 95.4138 23.9514Z",
    fill: "#25245F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5793 15.5416C31.1139 14.0527 30.2167 12.7174 28.9931 11.7444C27.443 10.5124 25.4697 9.93114 23.5026 9.94799C22.458 9.95641 21.4155 10.1417 20.432 10.4935C19.4506 10.8452 18.625 11.4664 17.7068 11.9424C17.5615 12.0182 17.4078 12.0877 17.2498 12.1488C16.6391 12.3826 15.9588 12.2478 15.447 11.8413L15.4407 11.8371C13.8907 10.6051 11.9173 10.0238 9.95027 10.0407C8.90568 10.0491 7.86319 10.2344 6.87967 10.5861C6.57429 10.6956 6.28366 10.8304 6.00145 10.9799C5.43071 11.2811 4.74835 11.2011 4.25343 10.7862C3.83854 10.4387 3.30572 10.2302 2.72234 10.2302H2.40223C1.07963 10.2302 0.00976562 11.3022 0.00976562 12.6227V26.3456C0.00976562 27.6682 1.08174 28.7381 2.40223 28.7381H2.72234C4.04494 28.7381 5.1148 27.6661 5.1148 26.3456V18.3026C5.30224 16.9063 6.05831 15.8302 7.42302 15.192C8.85302 14.5223 10.5526 14.7582 11.7804 15.7396C12.9914 16.7063 13.381 18.0478 13.381 19.5368V26.175C13.381 27.2407 14.0276 28.2284 15.0364 28.5738C16.0915 28.936 17.1003 28.6264 17.7531 27.9652C18.2628 27.4976 18.5871 26.8279 18.5871 26.0824C18.5871 23.6709 18.5956 21.2574 18.6272 18.846C18.6503 17.138 19.4169 15.8323 20.9796 15.0994C22.4096 14.4296 24.1092 14.6655 25.337 15.6469C26.548 16.6136 26.9376 17.9551 26.9376 19.4441V26.0824C26.9376 27.1712 27.6157 28.1715 28.654 28.5022C30.4189 29.0645 32.0426 27.763 32.0426 26.0824V21.6449C32.0426 19.6273 32.1964 17.4918 31.5835 15.5416H31.5793Z",
    fill: "#25245F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M141.802 25.6355C141.663 24.3213 140.452 23.3314 138.989 23.3314H136.992C136.329 23.3314 135.916 22.9755 135.752 22.6407C135.659 22.4532 135.547 22.0762 135.857 21.6677L141.147 14.7072C141.828 13.8122 141.819 12.6201 141.13 11.7293C140.623 10.9795 139.759 10.5352 138.812 10.5352H129.32C127.856 10.5352 126.647 11.525 126.506 12.8392C126.432 13.5342 126.653 14.2123 127.134 14.743C127.658 15.3264 128.427 15.6591 129.244 15.6591H131.649C132.22 15.6591 132.571 15.9624 132.713 16.2467C132.807 16.4363 132.868 16.7311 132.624 17.0512L127.115 24.3002C126.272 25.408 126.432 26.897 127.485 27.7689C127.856 28.0742 128.309 28.2806 128.802 28.3649C129.048 28.426 129.278 28.4554 129.501 28.4554H139.069C139.886 28.4554 140.654 28.1206 141.179 27.5393C141.657 27.0065 141.88 26.3304 141.806 25.6355H141.802Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M124.506 13.8108C124.362 11.6416 122.69 10.338 120.974 11.0983C119.666 11.6774 118.59 11.4816 117.328 11.132C111.442 9.49557 106.183 14.4806 106.019 19.4592C105.808 25.9206 112.042 30.1116 117.339 28.5721C118.24 28.3088 119.314 28.1656 120.201 28.3888C122.909 29.0754 124.44 28.1087 124.548 25.3393C124.615 23.5955 124.645 15.9 124.506 13.8129V13.8108ZM115.197 23.9514C112.906 23.9514 111.048 22.0939 111.048 19.8025C111.048 17.5112 112.906 15.6536 115.197 15.6536C117.488 15.6536 119.346 17.5112 119.346 19.8025C119.346 22.0939 117.488 23.9514 115.197 23.9514Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_470_3823",
    x1: 114.1,
    y1: 9.26937,
    x2: 138.071,
    y2: 30.5172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#009BFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#00ADE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#00BDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#00D2AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D6A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_470_3823",
    x1: 154.678,
    y1: 33.9827,
    x2: 131.875,
    y2: 14.8072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D6A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#00D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00CDB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#00C1C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#00B1DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#009DF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_470_3823",
    x1: 117.583,
    y1: 5.33911,
    x2: 141.551,
    y2: 26.5891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#009BFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#00ADE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#00BDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#00D2AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D6A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_470_3823",
    x1: 153.063,
    y1: 35.8998,
    x2: 130.259,
    y2: 16.7243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#00D6A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00D3AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#00CAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#00BDCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#00A9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_470_3823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156.154,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkaaz);
export default __webpack_public_path__ + "static/media/markaaz.73544584bd23334bcd75f2d61989bdd0.svg";
export { ForwardRef as ReactComponent };